import React, { useEffect, useState } from "react";
import CustomModel from "../Utility/CustomModel";
import { Editor } from "@tinymce/tinymce-react";
// import "../../public/custom.css";

const Citationpopup = ({ show, editor, handleCancel, currentNode }) => {
  const [currentData, setCurrentData] = useState("");

  useEffect(() => {
    if (!currentNode || !editor) return;

    let reftype = currentNode.getAttribute("ref-type");
    if (reftype === "bibr") {
      let currentRef = currentNode.getAttribute("rid");
      let reflist = editor.dom.select("ref-list")[0];

      if (reflist) {
        let children = editor.dom.select("ref", reflist);
        let selectedRef = children.find((ref) => ref.id === currentRef); // Use `find`, not `filter`
        if (selectedRef) {
          editor.dom.setStyle(selectedRef.childNodes[0], "opacity", "1");
          editor.dom.setStyle(selectedRef.childNodes[0], "display", "flex");
          editor.dom.setStyle(
            selectedRef.childNodes[0],
            "visibility",
            "visible"
          );
          setCurrentData(selectedRef.outerHTML);
        }
      }
    } else if (reftype === "fig") {
      let currentRef = currentNode.getAttribute("rid");
      let figurelist = editor.dom.select("fig");
      if (figurelist) {
        let selectedFig = figurelist.find((fig) => fig.id === currentRef);
        setCurrentData(selectedFig.outerHTML);
      }
    }
  }, [currentNode, editor]);

  return (
    <>
      {show && (
        <div
          className="w-full h-full fixed top-0 left-0 z-[1000]"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <CustomModel
            handleCancel={handleCancel}
            width={"60%"}
            heading={`Reference `}
          >
            <Editor
              value={currentData}
              init={{
                menubar: false,
                license_key: "gpl",
                toolbar: false,
                promotion: false,
                readonly: 1,
                plugins: [],
                branding: false,

                encoding: "xml",
                allow_script_urls: true,
                verify_html: false,
                content_style:
                  "body { font-family:Helvetica,Arial; font-size:14px }",
                content_css: "/vedas/custom.css", // must be inside /public
              }}
            />
          </CustomModel>
        </div>
      )}
    </>
  );
};

export default Citationpopup;
